
import withStyles from '@mui/styles/withStyles';
import MuiButton from '@mui/material/Button';

import CommonTheme from '../../../Theme';

/** ボタン共通部で使用するパレット */
const palette = CommonTheme.palette;

// ボタン共通スタイル
const styles = (theme) => {
  const ret = {
    root: {
      'border': '1px solid',
      'whiteSpace': 'nowrap',

      '&:disabled': {
        color: palette.text.disabled,
        backgroundImage: 'none',
        backgroundColor: palette.action.disabledBackground,
      },

      '&:hover': {
        backgroundColor: CommonTheme.mouse.color,
      },
    },
  };

  try {
    // 例外が発生する部分を切り出して後から設定
    const breakpointsUp = theme.breakpoints.up('sm');
    ret.root[breakpointsUp] = {
      'minWidth': 'auto',
    };
  } catch (err) {
    console.group('CommonButton error');
    console.error(err);
    console.dir(theme ? Object.assign({}, theme) : theme);
    console.groupEnd();
  } finally {
    return ret;
  }
};

/** ボタン共通部 */
export const CommonButton = withStyles(styles)(MuiButton);
export default CommonButton;
